<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="交易量统计" name="tradeVolume"></el-tab-pane>
      <el-tab-pane label="用户挂单查询" name="tradeOrder"></el-tab-pane>
      <el-tab-pane label="盘口挂单查询" name="unFinishOrder"></el-tab-pane>
    </el-tabs>
    <el-card v-show="type == 'tradeVolume'">
      <el-date-picker
        v-model="time"
        size="mini"
        class="search"
        placeholder="按月份搜索（如：202001）"
      ></el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryTradeVolumeData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="tradeVolumeData">
        <el-table-column label="用户Id" prop="userId"></el-table-column>
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="买入量" prop="buyAmount"></el-table-column>
        <el-table-column label="卖出量" prop="sellAmount"></el-table-column>
        <el-table-column label="净交易额" prop="netAmountForUsdt"></el-table-column>
        <el-table-column label="对usdt当前价格" prop="currentPrice"></el-table-column>
      </el-table>
    </el-card>
    <el-card v-show="type == 'tradeOrder'">
      <el-input
        v-model="userId"
        size="mini"
        placeholder="用户ID"
        class="search"
      ></el-input>
      <el-input
        v-model="pair"
        size="mini"
        placeholder="交易对"
        class="search"
      ></el-input>
      <el-input
        v-model="direction"
        size="mini"
        placeholder="方向，BID或者ASK"
        class="search"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryTradeOrderData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="tradeOrderData">
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="下单方向" prop="direction"></el-table-column>
        <el-table-column label="下单类型" prop="orderType"></el-table-column>
        <el-table-column label="成交数量" prop="dealAmount"></el-table-column>
        <el-table-column label="下单数量" prop="totalAmount"></el-table-column>
        <el-table-column label="下单价格" prop="price"></el-table-column>
        <el-table-column label="下单时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager.size"
          :page="pager.page"
          :total="tradeOrderTotal"
          @pageChanged="handlPageChanged"
        >
        </pagination>
      </div>
    </el-card>
    <el-card v-show="type == 'unFinishOrder'">
      <el-input
        v-model="pair"
        size="mini"
        placeholder="交易对"
        class="search"
      ></el-input>
      <el-input
        v-model="direction"
        size="mini"
        placeholder="方向，BID或者ASK"
        class="search"
      ></el-input>
      <el-input
        v-model="rangeEnd"
        size="mini"
        placeholder="数量"
        class="search"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryUnFinishTradeOrderData()"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="unFinishOrderData">
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="交易对" prop="pair"></el-table-column>
        <el-table-column label="下单方向" prop="direction"></el-table-column>
        <el-table-column label="下单类型" prop="orderType"></el-table-column>
        <el-table-column label="成交数量" prop="dealAmount"></el-table-column>
        <el-table-column label="下单数量" prop="totalAmount"></el-table-column>
        <el-table-column label="下单价格" prop="price"></el-table-column>
        <el-table-column label="下单时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterTradeVolume",
  data() {
    return {
      type: "tradeVolume",
      time: "",
      pair: "",
      userId: "",
      direction: "",
      rangeEnd: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getTradeVolumeData",
      "getTradeOrderData",
      "getUnFinishTradeOrderData",
    ]),
    queryTradeVolumeData() {
      let q = {};
      if (this.time) q.time = this.time.getTime();
      this.getTradeVolumeData(q);
    },
    queryTradeOrderData() {
      let q = {
        page: this.pager.page,
        size: this.pager.size,
      };
      if (this.userId) q.userId = this.userId;
      if (this.pair) q.pair = this.pair;
      if (this.direction) q.direction = this.direction;
      this.getTradeOrderData(q);
    },
    queryUnFinishTradeOrderData() {
      let q = {};
      if (this.pair) q.pair = this.pair;
      if (this.direction) q.direction = this.direction;
      if (this.rangeEnd) q.rangeEnd = this.rangeEnd;
      this.getUnFinishTradeOrderData(q);
    },
    tabChange() {
      if (this.type == "tradeVolume") {
        this.queryTradeVolumeData();
      } else if (this.type == "tradeOrder") {
        this.queryTradeOrderData();
      } else {
        this.queryUnFinishTradeOrderData();
      }
    },
    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryTradeOrderData();
    },
  },
  computed: {
    ...mapState("dataCenter", [
      "tradeVolumeData",
      "tradeOrderData",
      "tradeOrderTotal",
      "unFinishOrderData",
      "tableAble"
    ]),
  },
  watch: {
    tradeVolumeData() {
      formatTable();
    },
    tradeOrderData() {
      formatTable();
    },

    unFinishOrderData() {
        formatTable();
    }

  },
  mounted() {
    this.queryTradeVolumeData();
  },
  components: {
    Pagination,
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
